import moment from 'moment'

export class UpdateFarmTimeByIdUseCase {
  constructor(repository){
    this.repository=repository
  }
  async execute(ID_FARM) {
    const time= moment().format('YYYY-MM-DD HH:mm:ss')
    const resp= await this.repository.updateTime(ID_FARM,time)
    return resp
  }
}
